import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Phone } from 'lucide-react';
import './QuickAccess.css';

const QuickAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="quick-access-bar">
      {/* Sol Alt: Randevu Al Butonu */}
      <button 
        className="qa-btn qa-appointment" 
        onClick={() => navigate('/randevu-al')}
      >
        <Calendar size={28} strokeWidth={2.5} />
        <span>RANDEVU</span>
      </button>
      
      {/* Sağ Alt: Hemen Ara Butonu */}
      <a href="tel:+905076444022" className="qa-btn qa-call">
        <Phone size={28} strokeWidth={2.5} />
        <span>ARA</span>
      </a>
    </div>
  );
};

export default QuickAccess;